import { render, staticRenderFns } from "./BasketList.vue?vue&type=template&id=472c541a"
import script from "./BasketList.vue?vue&type=script&lang=js"
export * from "./BasketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports